import { useState, useEffect, useCallback } from 'react';
import api from './api';

export const DEFAULT_STATUSES = [
  { value: 'lead', label: 'Lead' },
  { value: 'customer', label: 'Customer' },
  { value: 'prospect', label: 'Prospect' },
  { value: 'inactive', label: 'Inactive' },
];

// The user's (customizable) ID/Status list. Falls back to the classic four.
export function useStatusOptions() {
  const [statuses, setStatuses] = useState(DEFAULT_STATUSES);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/settings/statuses');
      if (Array.isArray(data.statuses) && data.statuses.length) setStatuses(data.statuses);
    } catch { /* not logged in / offline — keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const save = useCallback(async (next) => {
    const { data } = await api.put('/settings/statuses', { statuses: next });
    setStatuses(data.statuses);
    return data.statuses;
  }, []);

  return { statuses, refresh, save };
}
